import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { io } from 'socket.io-client';

function Mesaje() {
  const [mesaje, setMesaje] = useState([]);
  const [incarca, setIncarca] = useState(true);
  const [idUtilizator, setIdUtilizator] = useState('');
  const [cheieConversatieActiva, setCheieConversatieActiva] = useState(null);
  const [textRaspuns, setTextRaspuns] = useState('');
  const [trimite, setTrimite] = useState(false);
  const navigate = useNavigate();
  const [modalContraOferta, setModalContraOferta] = useState(false);
  const [idMesajActiv, setIdMesajActiv] = useState(null);
  const [pretContraOferta, setPretContraOferta] = useState('');
  const [proceseaza, setProceseaza] = useState(false);

  const socketRef = useRef(null);
  const mesajeEndRef = useRef(null);

  const taburi = [
    { nume: 'Gestioneaza anunturile', link: '/anunturile-mele', activ: false },
    { nume: 'Comenzile mele', link: '/comenzi', activ: false },
    { nume: 'Mesaje', link: '/mesaje', activ: true },
    { nume: 'Favorite', link: '/favorite', activ: false },
    { nume: 'Alertele mele', link: '/alerte', activ: false },
    { nume: 'Detaliile mele', link: '/setari', activ: false }
  ];

  useEffect(function() {
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('utilizator');
    if (!token || !user) {
      navigate('/');
      return;
    }

    const userParsed = JSON.parse(user);
    const idUser = String(userParsed._id || userParsed.id);
    setIdUtilizator(idUser);
    incarcaMesaje(token);

    socketRef.current = io('https://tranzitio.onrender.com');
    socketRef.current.emit('inregistrare_user', idUser);

    socketRef.current.on('refresh_mesaje', function() {
      incarcaMesaje(token);
    });

    return function() {
      if (socketRef.current) {
        socketRef.current.disconnect();
      }
    };
  }, [navigate]);

  useEffect(function() {
    if (mesajeEndRef.current) {
      mesajeEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [mesaje, cheieConversatieActiva]);

  const incarcaMesaje = async function(token) {
    try {
      const raspuns = await fetch('https://tranzitio.onrender.com/api/mesaje/conversatiile-mele', {
        headers: { 'x-auth-token': token }
      });
      const date = await raspuns.json();
      if (raspuns.ok) {
        setMesaje(date);
      } else {
        toast.error(date.mesaj || 'Eroare necunoscuta');
      }
    } catch (err) {
      toast.error('Eroare la conectarea cu serverul');
    } finally {
      setIncarca(false);
    }
  };

  const formateazaData = function(dataString) {
    const d = new Date(dataString);
    return d.toLocaleDateString('ro-RO') + ' ' + d.toLocaleTimeString('ro-RO', { hour: '2-digit', minute: '2-digit' });
  };

  const handleTrimiteRaspuns = async function(e, conversatie) {
    e.preventDefault();
    const token = localStorage.getItem('token');

    if (textRaspuns.trim().length < 1) return;

    setTrimite(true);
    try {
      const idDestinatar = conversatie.interlocutor._id;
      const idAnunt = conversatie.anunt ? conversatie.anunt._id : null;

      const raspuns = await fetch('https://tranzitio.onrender.com/api/mesaje', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-auth-token': token
        },
        body: JSON.stringify({
          destinatar: idDestinatar,
          anunt: idAnunt,
          text: textRaspuns
        })
      });

      if (raspuns.ok) {
        setTextRaspuns('');
        incarcaMesaje(token);
        if (socketRef.current) {
          socketRef.current.emit('notifica_destinatar', idDestinatar);
        }
      } else {
        const dateEroare = await raspuns.json();
        toast.error(dateEroare.mesaj || 'Eroare la trimiterea raspunsului.');
      }
    } catch (eroare) {
      toast.error('Eroare de conexiune la trimitere.');
    } finally {
      setTrimite(false);
    }
  };
  async function handleRaspunsOferta(idMesaj, actiune, contraOfertaPret) {
    const token = localStorage.getItem('token');
    setProceseaza(true);
    try {
      const body = { actiune: actiune };
      if (actiune === 'contra-oferta') {
        if (!contraOfertaPret || Number(contraOfertaPret) <= 0) {
          toast.error('Introdu un pret valid pentru contra-oferta!');
          setProceseaza(false);
          return;
        }
        body.contraOfertaPret = Number(contraOfertaPret);
      }

      const raspuns = await fetch('https://tranzitio.onrender.com/api/mesaje/oferta/' + idMesaj + '/raspuns', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
        body: JSON.stringify(body)
      });
      const date = await raspuns.json();

      if (raspuns.ok) {
        if (actiune === 'acceptat') {
          toast.success('Ai acceptat oferta!');
        } else if (actiune === 'refuzat') {
          toast.success('Ai refuzat oferta.');
        } else {
          toast.success('Contra-oferta trimisa!');
        }
        setModalContraOferta(false);
        setPretContraOferta('');
        setIdMesajActiv(null);
        incarcaMesaje(localStorage.getItem('token'));
      } else {
        toast.error(date.mesaj);
      }
    } catch (err) {
      toast.error('Eroare la procesarea ofertei');
    } finally {
      setProceseaza(false);
    }
  }

  const handleStergeConversatie = async function(e, conv) {
    e.stopPropagation();
    if (!window.confirm('Sigur vrei sa stergi aceasta conversatie? Toate mesajele vor fi sterse definitiv.')) return;

    const token = localStorage.getItem('token');
    const idInterlocutor = conv.interlocutor ? String(conv.interlocutor._id || conv.interlocutor) : null;
    const idAnunt = conv.anunt ? String(conv.anunt._id || conv.anunt) : null;

    try {
      const raspuns = await fetch('https://tranzitio.onrender.com/api/mesaje/conversatie', {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'x-auth-token': token
        },
        body: JSON.stringify({
          idInterlocutor: idInterlocutor,
          idAnunt: idAnunt
        })
      });

      const date = await raspuns.json();
      if (raspuns.ok) {
        toast.success(date.mesaj);
        incarcaMesaje(token);
      } else {
        toast.error(date.mesaj);
      }
    } catch (eroare) {
      toast.error('Eroare de conexiune la stergere.');
    }
  };

  const grupuri = {};
  mesaje.forEach(function(mesaj) {
    const expId = mesaj.expeditor ? String(mesaj.expeditor._id || mesaj.expeditor) : '';
    const esteExpeditor = expId === idUtilizator;

    const interlocutor = esteExpeditor ? mesaj.destinatar : mesaj.expeditor;
    const idInterlocutor = interlocutor ? String(interlocutor._id || interlocutor) : 'necunoscut';
    const idAnunt = mesaj.anunt ? String(mesaj.anunt._id || mesaj.anunt) : 'sters';

    const cheie = idInterlocutor + '_' + idAnunt;

    if (!grupuri[cheie]) {
      grupuri[cheie] = {
        cheie: cheie,
        interlocutor: interlocutor,
        anunt: mesaj.anunt,
        mesaje: [],
        ultimulMesajData: mesaj.dataTrimiterii
      };
    }
    grupuri[cheie].mesaje.push(mesaj);
    if (new Date(mesaj.dataTrimiterii) > new Date(grupuri[cheie].ultimulMesajData)) {
      grupuri[cheie].ultimulMesajData = mesaj.dataTrimiterii;
    }
  });

  const conversatii = Object.values(grupuri).sort(function(a, b) {
    return new Date(b.ultimulMesajData) - new Date(a.ultimulMesajData);
  });

  const conversatieActiva = conversatii.find(function(c) {
    return c.cheie === cheieConversatieActiva;
  });

  if (incarca) return <div className="text-center mt-20 font-bold text-xl text-gray-500">Se incarca...</div>;

  return (
    <div className="min-h-screen bg-[#f3f4f6]">
      <div className="bg-white border-b border-gray-200 overflow-x-auto">
        <div className="max-w-7xl mx-auto px-4 flex min-w-max">
          {taburi.map(function(tab, index) {
            return (
              <Link
                key={index}
                to={tab.link}
                className={`flex items-center gap-2 px-6 py-4 text-sm font-bold transition-all border-b-4 ${tab.activ ? 'border-blue-600 text-blue-700' : 'border-transparent text-gray-500 hover:text-gray-800 hover:bg-gray-50'}`}
              >
                {tab.nume}
              </Link>
            );
          })}
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-4 py-8">

        {!cheieConversatieActiva ? (
          <div>
            <div className="flex flex-col md:flex-row justify-between items-center mb-6">
              <h2 className="text-xl font-bold text-gray-800 mb-4 md:mb-0">
                Casuta ta de mesaje
              </h2>
            </div>

            {conversatii.length === 0 ? (
              <div className="flex flex-col items-center justify-center py-24 bg-white rounded-xl shadow-sm border border-gray-100">
                <div className="w-24 h-24 bg-blue-50 rounded-full flex items-center justify-center mb-6">
                  <svg className="w-12 h-12 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                  </svg>
                </div>
                <h3 className="text-2xl font-black text-gray-800 mb-2">Nicio conversatie momentan</h3>
                <p className="text-gray-500 font-medium mb-8 text-center max-w-sm">
                  Aici vor aparea discutiile tale cu alti utilizatori de pe platforma.
                </p>
                <Link to="/" className="bg-blue-600 text-white font-bold px-8 py-3.5 rounded-xl hover:bg-blue-700 transition-all">
                  Inapoi la anunturi
                </Link>
              </div>
            ) : (
              <div className="grid grid-cols-1 gap-4">
                {conversatii.map(function(conv) {
                  const ultimulMesaj = conv.mesaje[conv.mesaje.length - 1];
                  const numePersoana = conv.interlocutor ? conv.interlocutor.nume : 'Utilizator sters';
                  const titluAnunt = conv.anunt ? conv.anunt.titlu : 'Anunt indisponibil';
                  const initiala = numePersoana.charAt(0).toUpperCase();

                  const expUltimulId = ultimulMesaj.expeditor ? String(ultimulMesaj.expeditor._id || ultimulMesaj.expeditor) : '';
                  const ultimulEsteAlMeu = expUltimulId === idUtilizator;

                  return (
                    <div
                      key={conv.cheie}
                      onClick={function() { setCheieConversatieActiva(conv.cheie); }}
                      className="bg-white rounded-xl shadow-sm border border-gray-200 p-4 flex items-center gap-4 cursor-pointer hover:shadow-md hover:border-blue-300 transition-all"
                    >
                      <div className="w-14 h-14 bg-blue-100 rounded-full flex items-center justify-center text-blue-700 font-black text-xl shrink-0">
                        {initiala}
                      </div>
                      <div className="flex-grow min-w-0">
                        <div className="flex justify-between items-start mb-1">
                          <h3 className="font-bold text-gray-900 truncate">{numePersoana}</h3>
                          <span className="text-xs font-bold text-gray-400 whitespace-nowrap ml-2">
                            {formateazaData(conv.ultimulMesajData)}
                          </span>
                        </div>
                        <p className="text-xs font-bold text-blue-600 mb-1 truncate">{titluAnunt}</p>
                        <div className="text-sm text-gray-500 truncate flex items-center gap-1">
                          {ultimulEsteAlMeu && (
                            ultimulMesaj.citit ? (
                              <svg className="w-4 h-4 text-blue-500 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 12l5 5L20 7M1 12l5 5L16 7" />
                              </svg>
                            ) : (
                              <svg className="w-4 h-4 text-gray-400 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 12l5 5L20 7" />
                              </svg>
                            )
                          )}
                          <span className="truncate">{ultimulMesaj.text}</span>
                        </div>
                      </div>
                      <button
                        onClick={function(e) { handleStergeConversatie(e, conv); }}
                        className="shrink-0 w-9 h-9 bg-red-50 text-red-500 rounded-lg flex items-center justify-center hover:bg-red-100 transition"
                        title="Sterge conversatia"
                      >
                        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                      </button>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        ) : (
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 flex flex-col h-[700px] max-h-[80vh]">

            <div className="p-4 border-b border-gray-200 flex items-center justify-between bg-gray-50 rounded-t-xl">
              <div className="flex items-center gap-4">
                <button
                  onClick={function() { setCheieConversatieActiva(null); }}
                  className="w-10 h-10 bg-white border border-gray-300 rounded-full flex items-center justify-center text-gray-600 hover:bg-gray-100 transition"
                >
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                </button>
                <div>
                  <h3 className="font-bold text-gray-900 text-lg">
                    {conversatieActiva.interlocutor ? conversatieActiva.interlocutor.nume : 'Utilizator necunoscut'}
                  </h3>
                  <p className="text-xs font-bold text-blue-600">
                    {conversatieActiva.anunt ? conversatieActiva.anunt.titlu : 'Anunt indisponibil'}
                  </p>
                </div>
              </div>
              <button
                onClick={function(e) { handleStergeConversatie(e, conversatieActiva); setCheieConversatieActiva(null); }}
                className="flex items-center gap-2 bg-red-50 text-red-500 px-3 py-2 rounded-lg hover:bg-red-100 transition font-bold text-sm"
              >
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
                Sterge conversatia
              </button>
            </div>

            <div className="flex-grow p-6 overflow-y-auto flex flex-col gap-4 bg-[#f9fafb]">
              {conversatieActiva.mesaje.map(function(mesaj) {
                  const expMsgId = mesaj.expeditor ? String(mesaj.expeditor._id || mesaj.expeditor) : '';
                  const esteAlMeu = expMsgId === idUtilizator;

                  if (mesaj.tipMesaj === 'oferta' || mesaj.tipMesaj === 'contra-oferta') {
                    const esteInAsteptare = mesaj.statusOferta === 'in_asteptare';
                    const potRaspunde = !esteAlMeu && esteInAsteptare;
                    return (
                      <div key={mesaj._id} className={'flex mb-2 ' + (esteAlMeu ? 'justify-end' : 'justify-start')}>
                        <div className={'w-64 rounded-2xl overflow-hidden border-2 ' + (mesaj.tipMesaj === 'contra-oferta' ? 'border-purple-200' : 'border-amber-200')}>
                          <div className={'px-4 py-2 text-white text-xs font-bold ' + (mesaj.tipMesaj === 'contra-oferta' ? 'bg-purple-500' : 'bg-amber-500')}>
                            {mesaj.tipMesaj === 'contra-oferta' ? '↩ Contra-oferta' : '💰 Oferta'}
                          </div>
                          <div className="bg-white px-4 py-3">
                            <p className="text-2xl font-black text-gray-900 mb-2">{mesaj.pretOferta} RON</p>
                            {mesaj.statusOferta === 'acceptat' && (
                              <span className="text-xs font-bold text-emerald-600 bg-emerald-50 px-2 py-1 rounded-full">✓ Acceptata</span>
                            )}
                            {mesaj.statusOferta === 'refuzat' && (
                              <span className="text-xs font-bold text-red-600 bg-red-50 px-2 py-1 rounded-full">✗ Refuzata</span>
                            )}
                            {esteInAsteptare && !potRaspunde && (
                              <span className="text-xs font-bold text-amber-600 bg-amber-50 px-2 py-1 rounded-full">⏳ In asteptare</span>
                            )}
                            {potRaspunde && (
                              <div className="flex flex-col gap-2 mt-2">
                                <button
                                  onClick={function() { handleRaspunsOferta(mesaj._id, 'acceptat'); }}
                                  disabled={proceseaza}
                                  className="w-full py-2 rounded-lg font-bold text-white bg-emerald-500 hover:bg-emerald-600 transition text-sm disabled:opacity-50"
                                >
                                  ✓ Accepta
                                </button>
                                <button
                                  onClick={function() { setIdMesajActiv(mesaj._id); setModalContraOferta(true); }}
                                  disabled={proceseaza}
                                  className="w-full py-2 rounded-lg font-bold text-white bg-purple-500 hover:bg-purple-600 transition text-sm disabled:opacity-50"
                                >
                                  ↩ Contra-oferta
                                </button>
                                <button
                                  onClick={function() { handleRaspunsOferta(mesaj._id, 'refuzat'); }}
                                  disabled={proceseaza}
                                  className="w-full py-2 rounded-lg font-bold text-red-600 bg-red-50 hover:bg-red-100 transition text-sm disabled:opacity-50"
                                >
                                  ✗ Refuza
                                </button>
                              </div>
                            )}
                          </div>
                          <div className="px-4 py-1 bg-gray-50 text-xs text-gray-400">
                            {formateazaData(mesaj.dataTrimiterii)}
                          </div>
                        </div>
                      </div>
                    );
                  }

                  if (mesaj.tipMesaj === 'acceptat') {
                    return (
                      <div key={mesaj._id} className="flex justify-center mb-2">
                        <div className="bg-emerald-50 border border-emerald-200 rounded-xl px-5 py-3 text-center">
                          <p className="font-bold text-emerald-700">🎉 Oferta de {mesaj.pretOferta} RON a fost acceptata!</p>
                          <p className="text-xs text-emerald-600 mt-1">Puteti merge mai departe cu tranzactia.</p>
                        </div>
                      </div>
                    );
                  }

                  if (mesaj.tipMesaj === 'refuzat') {
                    return (
                      <div key={mesaj._id} className="flex justify-center mb-2">
                        <div className="bg-red-50 border border-red-200 rounded-xl px-5 py-3 text-center">
                          <p className="font-bold text-red-700">Oferta de {mesaj.pretOferta} RON a fost refuzata.</p>
                        </div>
                      </div>
                    );
                  }

                  return (
                    <div key={mesaj._id} className={'flex flex-col max-w-[75%] ' + (esteAlMeu ? 'self-end items-end' : 'self-start items-start')}>
                      <div className={'px-4 py-3 rounded-2xl ' + (esteAlMeu ? 'bg-blue-600 text-white rounded-tr-sm' : 'bg-white border border-gray-200 text-gray-800 rounded-tl-sm shadow-sm')}>
                        <p className="whitespace-pre-wrap text-sm leading-relaxed">{mesaj.text}</p>
                      </div>
                      <div className="flex items-center gap-1 mt-1 mx-1">
                        <span className="text-[10px] font-bold text-gray-400">
                          {formateazaData(mesaj.dataTrimiterii)}
                        </span>
                        {esteAlMeu && (
                          mesaj.citit ? (
                            <svg className="w-3 h-3 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 12l5 5L20 7M1 12l5 5L16 7" />
                            </svg>
                          ) : (
                            <svg className="w-3 h-3 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 12l5 5L20 7" />
                            </svg>
                          )
                        )}
                      </div>
                    </div>
                  );
                })}
                <div ref={mesajeEndRef} />
            </div>

            <div className="p-4 border-t border-gray-200 bg-white rounded-b-xl">
              <form onSubmit={function(e) { handleTrimiteRaspuns(e, conversatieActiva); }} className="flex gap-2">
                <input
                  type="text"
                  value={textRaspuns}
                  onChange={function(e) { setTextRaspuns(e.target.value); }}
                  placeholder="Scrie un mesaj..."
                  className="flex-grow border border-gray-300 rounded-full px-6 py-3 focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600 bg-gray-50"
                  disabled={trimite}
                />
                <button
                  type="submit"
                  disabled={trimite || textRaspuns.trim().length === 0}
                  className="w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center hover:bg-blue-700 transition disabled:bg-gray-300 shrink-0"
                >
                  {trimite ? (
                    <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  ) : (
                    <svg className="w-5 h-5 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
                    </svg>
                  )}
                </button>
              </form>
            </div>

          </div>
        )}
        {modalContraOferta === true && (
          <div className="fixed inset-0 z-[100] bg-black/60 flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-6">
              <h3 className="text-lg font-bold text-gray-900 mb-4">Trimite o contra-oferta</h3>
              <div className="mb-4">
                <label className="block text-sm font-bold text-gray-700 mb-2">Pretul tau (RON)</label>
                <input
                  type="number"
                  value={pretContraOferta}
                  onChange={function(e) { setPretContraOferta(e.target.value); }}
                  placeholder="Introdu suma"
                  className="w-full border border-gray-200 rounded-xl px-4 py-3 text-lg font-bold focus:outline-none focus:border-purple-500 transition"
                />
              </div>
              <div className="flex gap-3">
                <button
                  onClick={function() { setModalContraOferta(false); setPretContraOferta(''); }}
                  className="flex-1 py-3 rounded-xl font-bold text-gray-700 bg-gray-100 hover:bg-gray-200 transition"
                >
                  Anuleaza
                </button>
                <button
                  onClick={function() { handleRaspunsOferta(idMesajActiv, 'contra-oferta', pretContraOferta); }}
                  disabled={proceseaza}
                  className="flex-1 py-3 rounded-xl font-bold text-white bg-purple-500 hover:bg-purple-600 transition disabled:opacity-50"
                >
                  {proceseaza ? 'Se trimite...' : 'Trimite'}
                </button>
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}

export default Mesaje;